{
  "de": {
    "aiImage": {
      "confirm": {
        "deleteImage": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Bild wird dauerhaft aus deinem Verlauf entfernt.",
          "title": "Bild entfernen?"
        },
        "moveAllToTrash": {
          "text": "Alle Bilder werden aus deinem Verlauf entfernt. Du findest sie danach im Papierkorb.",
          "title": "Bilder in den Papierkorb verschieben?"
        }
      },
      "errors": {
        "generationFailed": "Bilderzeugung fehlgeschlagen. Bitte versuche es erneut.",
        "generationTimeout": "Die Bildgenerierung dauert ungewöhnlich lange und wurde abgebrochen. Bitte versuche es erneut.",
        "loadFailed": "Das Bild konnte nicht geladen werden. Es wurde möglicherweise entfernt oder du hast keinen Zugriff darauf.",
        "rateLimitExceeded": "Du hast zu viele Bilder in kurzer Zeit erstellt. Bitte warte einen Moment und versuche es erneut."
      },
      "headers": {
        "form": "Eigenes Bild anlegen lassen",
        "proposals": "Vorschläge"
      },
      "hints": {
        "progressMessage": "Bild wird generiert..."
      },
      "imageStyles": {
        "concept_art": "Konzept Art",
        "custom": "Standard",
        "drawing": "Zeichnung",
        "graphics_3d": "3D Grafik",
        "origami": "Origami",
        "painting": "Gemälde",
        "photo": "Foto",
        "polaroid": "Polaroid"
      },
      "labels": {
        "copyPrompt": "Prompt kopieren",
        "create": "Bild anlegen",
        "createdAt": "Erstellt am",
        "imageSize": "Bildgröße",
        "imageStyle": "Stil",
        "model": "Modell",
        "openImageInNewTab": "Bild in neuem Tab öffnen",
        "prompt": "Prompt",
        "promptDescribe": "Beschreibe das Bild",
        "provider": "Anbieter",
        "providerInfo": "Mehr Informationen",
        "result": "Ergebnis",
        "size": "Größe"
      },
      "messages": {
        "allMovedToTrash": "Alle Bilder wurden in den Papierkorb verschoben",
        "deleted": "Bild gelöscht"
      },
      "prompts": {
        "prompt1": "Foto eines Marienkäfers aus der Vogelperspektive, der auf einem saftigen grünen Grashalm in einer sonnigen Wiese sitzt. Der Marienkäfer hat leuchtend rote Flügel mit schwarzen Punkten. Im Hintergrund sind verschwommene Blumen und ein klarer blauer Himmel zu sehen. Die Szene ist in einem hellen, lebendigen Stil gehalten, mit Fokus auf den Marienkäfer.",
        "prompt2": "Ein fotorealistisches Porträt einer jungen Ingenieurstudentin mit kurzen schwarzen Haaren, die verträumt aus einem großen Fenster in einem modernen Universitätsgebäude blickt. Die Aufnahme ist in einem sanften, warmen Tageslicht gehalten und die Kamera ist auf Augenhöhe positioniert. Im Hintergrund sind verschwommene Bücherregale und technische Zeichnungen zu sehen, was der Szene eine akademische und inspirierende Atmosphäre verleiht.",
        "prompt3": "Ein impressionistisches Gemälde eines Mannes mittleren Alters, der mit einem schwarzen Regenschirm im Sturm am Ufer eines reißenden Flusses entlangläuft. Die Szene ist in weichen, fließenden Pinselstrichen dargestellt, die die Bewegung des Windes und des Regens einfangen. Der Himmel ist in dramatischen Grautönen gehalten, während der Fluss in tiefen Blau- und Grüntönen schimmert. Der Mann trägt einen langen, dunklen Mantel, der im Wind flattert, und die Farben seines Mantels und Regenschirms sind leicht verschwommen, um die Intensität des Sturms zu betonen."
      },
      "tooltips": {
        "generatePrompt": "Prompt optimieren",
        "generatePromptDisabled": "Gib zuerst einen Prompt ein, um ihn zu optimieren"
      },
      "views": {
        "new": {
          "labels": {
            "imageStyle": "Wähle einen Stil"
          }
        }
      }
    }
  }
}
